<template>
    <div class="diff-container" v-loading="pageLoading">
        <div class="diff-part">
            <div class="mb-20">新文</div>
            <div v-html="newContent" class="content-box"></div>
        </div>
        <div class="diff-part">
            <div class="mb-20">差异</div>
            <div v-html="diffContent" class="content-box"></div>
        </div>
        <div class="diff-part">
            <div class="mb-20">原文</div>
            <div v-html="oldContent" class="content-box"></div>
            <!-- <tinymce v-model="oldContent" :toolbar="toolbar" :menubar="false" :statusbar="false" :isReadOnly="true"></tinymce> -->
        </div>
    </div>
</template>

<script>
import htmlDiff from '@/assets/js/htmldiff';
// import Tinymce from '@/components/Tinymce'; 
export default {
    data(){
        return {
            diffContent: '',
            // toolbar:[''],
            pageLoading: false
        }
    },
    props: {
        oldContent: {
            type: String,
            default: ''
        },
        newContent: {
            type: String,
            default: ''
        }
    },
    // components:{Tinymce},
    watch: {
        oldContent: {
            handler(n){
                this.diff(n, this.newContent)
            },
            immediate: true            
        }
    },
    methods: {
        diff(o, n){
            this.diffContent = htmlDiff(o, n);
        }
    }
}
</script>

<style lang="scss">
.diff-container{
    display: flex;
    align-items: top;
    .diff-part{
        width: 35%;
        padding: 0 20px;
        border-right: 1px solid #ccc;
        &:nth-last-child(1){
            border: none;
        }
    }
    .mb-20{
        margin-bottom: 20px;
    }
    .content-box{
        border: 1px solid #ccc;
        padding: 10px;
        img{
            max-width: 100% !important;
            height: auto;
        }
        iframe {
            width: 100%;
        }
    }
    ::v-deep .diffNew {
        background-color: #cfc;
        text-decoration: none;
    }
    ::v-deep .diffOld {
        color: #999;
        background-color: #FEC8C8;
    }
}
</style>